"use client";

import { CareFormStatusBadge } from "@/care-forms/components/care-forms/status-badge";
import {
	Box,
	Card,
	Container,
	Flex,
	Group,
	Loader,
	Stack,
	Text,
	Title,
} from "@mantine/core";
import { Link } from "react-router";

import { CaregiverAppSettingsButton } from "@/caregiver-app/components/CaregiverAppSettingsButton";
import { trpc } from "@/common/utils/trpc";
import { ROUTES } from "@/setup/frontend/routes";

export default function CaregiverAppFormsIndexPage() {
	const {
		data: forms,
		isLoading,
		error,
	} = trpc.caregiverForms.listMyIncompleteForms.useQuery();

	if (isLoading) {
		return (
			<Flex direction="column" h="100vh">
				<Box style={{ borderBottom: "1px solid var(--mantine-color-gray-3)" }}>
					<Group h={64} px="md" justify="space-between">
						<CaregiverAppSettingsButton />
						<Title order={3} style={{ flex: 1, textAlign: "center" }}>
							Forms
						</Title>
						<Box w={48} />
					</Group>
				</Box>
				<Flex align="center" justify="center" style={{ flex: 1 }}>
					<Loader size="lg" color="blue" />
				</Flex>
			</Flex>
		);
	}

	if (error) {
		return (
			<Flex direction="column" w="100%">
				<Box style={{ borderBottom: "1px solid var(--mantine-color-gray-3)" }}>
					<Group h={64} px="md" justify="space-between">
						<CaregiverAppSettingsButton />
						<Title order={3} style={{ flex: 1, textAlign: "center" }}>
							Forms
						</Title>
						<Box w={48} />
					</Group>
				</Box>
				<Container p="md">
					<Card withBorder>
						<Stack align="center" gap="md" p="md">
							<Text c="red" size="md">
								Error Loading Forms
							</Text>
							<Text c="red" size="sm">
								{error.message}
							</Text>
						</Stack>
					</Card>
				</Container>
			</Flex>
		);
	}

	return (
		<Flex direction="column" style={{ overflow: "hidden" }} flex={1}>
			<Box style={{ borderBottom: "1px solid var(--mantine-color-gray-3)" }}>
				<Group h={64} px="md" justify="space-between">
					<CaregiverAppSettingsButton />
					<Title order={3} style={{ flex: 1, textAlign: "center" }}>
						Forms
					</Title>
					<Box w={48} />
				</Group>
			</Box>

			<Box style={{ flex: 1, overflowY: "auto" }}>
				<Container p="md">
					<Stack gap="md">
						{forms?.map((form) => (
							<Card
								key={`${form.careFormTypeId}-${form.clientId}`}
								style={{ cursor: "pointer" }}
								component={Link}
								to={ROUTES.CAREGIVER_APP.FORMS.DETAIL({
									careFormTypeId: form.careFormTypeId,
									clientId: form.clientId,
									payerSourceId: form.payerSourceId,
								})}
								withBorder
							>
								<Group justify="space-between" align="flex-start">
									<Stack gap="xs">
										<Title order={4}>{form.careFormTypeDisplayName}</Title>
										<Text size="sm" fw={500}>
											{form.clientFirstName} {form.clientLastName}
										</Text>
									</Stack>
									<CareFormStatusBadge status={"todo"} />
								</Group>
							</Card>
						))}

						{forms?.length === 0 && (
							<Card>
								<Stack align="center" p="md">
									<Text c="dimmed">No forms to complete</Text>
								</Stack>
							</Card>
						)}
					</Stack>
				</Container>
			</Box>
		</Flex>
	);
}
